import React from 'react';

const Separator = ({hide, hideOnMob}) => {
    return (
        <div className={`sep  ${hide && "hide"}   ${hideOnMob && "hideOnMob"}`}></div>
    );
};

export default Separator;